import { useState } from 'react'

import { useProductsQuery, UseProductsQueryProps } from '../useProductsQuery'

export interface UseProductSearchProps extends UseProductsQueryProps {
  defaultSearchValue?: string
}

export function useProductSearch<Product>(options: UseProductSearchProps = {}) {
  const { debounce = 500, defaultSearchValue = '', ...restOptions } = options

  const [searchValue, setSearchValue] = useState(defaultSearchValue)

  const query = useProductsQuery<Product>(
    {
      ...restOptions,
      debounce,
      search: searchValue,
    },
    {
      enabled: searchValue && searchValue !== '',
    },
  )

  return {
    ...query,
    searchValue,
    setSearchValue,
  }
}

export default useProductSearch
